function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_23816",
  fill: "#6e6e6f",
  d: "M3.048 5.791A2.843 2.843 0 0 1 0 2.9 2.89 2.89 0 0 1 3.2 0a2.764 2.764 0 0 1 3.049 2.9 2.89 2.89 0 0 1-3.201 2.891zm2.9 19.051H.3V8.077h5.644zm20.118 0h-5.643V15.85c0-2.286-.762-3.81-2.9-3.81a3.263 3.263 0 0 0-2.9 1.981 3.784 3.784 0 0 0-.152 1.372v9.449H8.992V8.077h5.639v2.438a5.458 5.458 0 0 1 5.029-2.9c3.658 0 6.4 2.438 6.4 7.62v9.6z",
  "data-name": "Path 23816"
});

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "linkedin",
    width: 26.062,
    height: 24.842,
    viewBox: "0 0 26.062 24.842",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.9d679bc7.svg";
export { ForwardRef as ReactComponent };